// The post-signup survey's questions. Kept out of SignupSurveyModal.tsx so
// the component module only exports components (Vite Fast Refresh) and the
// answer lists can be checked without rendering.

export type SignupSurveyStep = {
  key: "role" | "referral";
  title: string;
  options: string[];
  multi?: boolean;
  /**
   * Answer grid: 2 columns (1 on phones) by default; 3 (2 on phones) for a
   * step with too many answers for that. The dialog doesn't scroll, so a
   * long single column pushes the title and Back off a phone screen.
   */
  columns?: 2 | 3;
};

export const SIGNUP_SURVEY_STEPS: SignupSurveyStep[] = [
  {
    key: "role",
    title: "What best describes you?",
    options: [
      "Musician / Singer / Producer",
      "Content Creator / Influencer",
      "Business / Marketing",
      "Just for fun / Experimenting",
      "Student",
      "Other",
    ],
  },
  {
    key: "referral",
    title: "How did you hear about us?",
    // One answer per assistant so the referral mix shows which AI sends
    // people, not just "an LLM did". Before Oct 11 2026 these four were a
    // single "ChatGPT / Grok / Gemini / Claude" answer; older
    // `survey_referral` values in PostHog keep that string.
    options: [
      "Google / Bing",
      "ChatGPT",
      "Gemini",
      "Claude",
      "Other AI (Grok, Perplexity…)",
      "Friends / Colleagues",
      "Facebook",
      "TikTok",
      "Instagram",
      "YouTube",
      "Reddit",
      "Other",
    ],
    columns: 3,
  },
];

// Answers where a person sent them: a friend, a Rewards poster, a sponsored
// creator. Picking one records the survey as before, then asks the optional
// "Who told you about Solmi?" (a name, @handle or creator code).
export const ASK_WHO_REFERRALS = new Set([
  "Friends / Colleagues",
  "TikTok",
  "Instagram",
  "YouTube",
  "Facebook",
]);
